// @flow
import addResourceAnnotations from 'app/packages/trace-logger/utils/addResourceAnnotations';
import Stopwatch from 'app/packages/trace-logger/Stopwatch';
import { getEntries } from 'app/packages/trace-logger/resourceTiming';
import type { CustomTraceEvent, CustomEventHook } from 'app/common/lib/TraceLogger/types';

const pinCloseupDetailsHook: CustomEventHook = () => {
  let currentImageSrc;
  return (event: CustomTraceEvent, timer: Stopwatch) => {
    if (event.name === 'CloseupImageSrcAcquired') {
      currentImageSrc = event.imgSrc;
      return true;
    }
    if (event.name === 'CloseupImageRenderedTraceEvent') {
      const imageEndTimestamp = Date.now();
      const timingObject = getEntries().find((e) => e.name === currentImageSrc);
      timer.addAnnotation('CloseupImageRenderedTraceEvent', imageEndTimestamp);
      if (currentImageSrc && timingObject) {
        const imageStopwatch = timer.addSubStopwatch(
          new Stopwatch({
            name: 'image',
            metricName: timer.metricName,
            parent: timer,
            startTime: window.performance.timing.navigationStart + timingObject.startTime,
            endTime: imageEndTimestamp,
          }),
        );
        addResourceAnnotations(imageStopwatch, timingObject);
      }
      return true;
    }
    return false;
  };
};

export default pinCloseupDetailsHook;
